export default __webpack_public_path__ + "static/media/vitalik_nft_15.a98ea38c.svg";